<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/dxVUAQ/tc-custom/9783958647251_IMGJPG_FrontCover_0.jpg?1703128686433" alt="This image is the cover for the book Mistress Wilding, Classics To Go"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Mistress Wilding, Classics To Go
      </h1>
      <p class="bookDescription body article font2">
        <p>Rafael Sabatini (29 April 1875 – 13 February 1950) was an Italian/English writer of novels of romance and adventure.About the book: In the days just before England’s Monmouth Rebellion, Anthony Wilding takes advantage of an insult to force a marriage with the woman he loves. Wilding regrets his rash action after his commitment to the Duke of Monmouth separates him from his new bride, but the botched military campaign threatens to make the new Mistress Wilding a widow — unless a rival suitor manages it first.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Rafael Sabatini
      </h2>
      
      <p class="authorDescription body article">Rafael Sabatini (29 April 1875 – 13 February 1950) was an Italian-English writer of romance and adventure novels. He is best known for his worldwide bestsellers: The Sea Hawk (1915), Scaramouche (1921), Captain Blood (a.k.a. The Odyssey of Captain Blood) (1922), and Bellarion the Fortunate (1926). In all, Sabatini produced 34 novels, eight short story collections, six non-fiction books, numerous uncollected short stories, and several plays. (Wikipedia)</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      OTB ebook
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3f8abe56